// @ts-nocheck
import {
  Box,
  Button,
  Grid,
  Heading,
  Stack,
  Text,
} from "@smoothie-framework/ui";
import { creators } from "./content";
import { asset, Gutter, Icon } from "./shared";

function CreatorCard({
  creator,
  featured = false,
}: {
  creator: (typeof creators)[number];
  featured?: boolean;
}) {
  return (
    <Box
      as="article"
      background="surface2"
      className={`creator ${creator.className}${featured ? " creator-featured" : ""}`}
    >
      <img src={asset(creator.image)} alt={creator.name} />
      <Stack
        className="creator-overlay"
        gap={2}
        p={{ base: 4, md: 6 }}
      >
        <Heading level={3} textStyle="h3">
          {creator.name}
        </Heading>
        <Text as="p" textStyle="caption" color="accent">
          {creator.genre}
        </Text>
        <Text as="p" textStyle="body-sm" color="subtle">
          {creator.bio}
        </Text>
      </Stack>
    </Box>
  );
}

export function Creators() {
  return (
    <Box
      as="section"
      className="creators section-paper"
      py={{ base: 16, md: 20 }}
      id="request"
    >
      <Gutter>
        <Heading level={2} textStyle="h1">
          Meet the storytellers.
        </Heading>
        <Text
          as="p"
          className="creator-intro"
          textStyle="body"
          color="subtle"
          mt={4}
        >
          Meet the writers, fanfiction authors and digital creators behind the
          stories.
        </Text>
        <Grid
          className="creator-grid"
          gap={{ base: 4, md: 6 }}
          mt={{ base: 9, md: 14 }}
        >
          <Stack
            className="creator-column creator-column-mira"
            gap={6}
            h={{ base: "auto", lg: 170 }}
          >
            <CreatorCard creator={creators[0]} />
            <img
              aria-hidden="true"
              alt=""
              className="creator-accent creator-accent-mira"
              src={asset("creator-mira-gradient.png")}
            />
          </Stack>
          <CreatorCard creator={creators[1]} featured />
          <Stack
            className="creator-column creator-column-amara"
            gap={6}
            h={{ base: "auto", lg: 170 }}
          >
            <img
              aria-hidden="true"
              alt=""
              className="creator-accent creator-accent-amara"
              src={asset("creator-amara-gradient.png")}
            />
            <CreatorCard creator={creators[2]} />
          </Stack>
        </Grid>
        <Stack
          align={{ base: "stretch", lg: "end" }}
          className="closing"
          borderTopWidth="sm"
          borderTopStyle="solid"
          borderTopColor="borderSubtle"
          direction={{ base: "column", lg: "row" }}
          gap={6}
          justify="between"
          mt={{ base: 12, md: 16 }}
          pt={7}
        >
          <Box>
            <Heading level={3} textStyle="h2">
              Make your next story a series.
            </Heading>
            <Text as="p" mt={2} textStyle="body-sm" color="subtle">
              Request an invitation to the Zequels private beta.
            </Text>
          </Box>
          <Button asChild variant="primary">
            <a href="mailto:joram@zequels.com?subject=Zequels%20private%20beta">
              Request access
            </a>
          </Button>
        </Stack>
      </Gutter>
    </Box>
  );
}
